import React, { ReactNode } from "react";

import EmbeddedHeader from "../teacher/Header/EmbeddedHeader";
import Portal from "../../atoms/Portal";

import styles from "./EmbeddedHeaderModal.module.scss";

export interface EmbeddedHeaderModalProps {
  isOpen: boolean;
  title: string;
  onClose?: () => void;
  children: ReactNode;
}

const EmbeddedHeaderModal = ({
  isOpen,
  title,
  onClose,
  children,
}: EmbeddedHeaderModalProps) => {
  return isOpen ? (
    <Portal>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <EmbeddedHeader title={title} goBack={onClose} />
          <div className={styles.content}>{children}</div>
        </div>
      </div>
    </Portal>
  ) : null;
};
export default EmbeddedHeaderModal;
